import { orderUploadStyles as orderUploadStyle } from "@insite/content-library/Components/OrderUpload";
import { css } from "styled-components";

orderUploadStyle.downloadTemplateButton = {
    ...orderUploadStyle.downloadTemplateButton,
    variant: "secondary",
};

orderUploadStyle.fileUploader = {
    ...orderUploadStyle.fileUploader,
    buttonProps: {
        ...orderUploadStyle.fileUploader?.buttonProps,
        variant: "secondary",
        sizeVariant: "small",
    },
};

orderUploadStyle.includeFirstRowCheckbox = {
    ...orderUploadStyle.includeFirstRowCheckbox,
    css: css`
        ${orderUploadStyle.includeFirstRowCheckbox?.css}
        display: flex;
    `,
};
